<template>
  <div>
    <div v-for="i in Array.from({ length: count }, (_, x) => x)" :key="'loading-'+ _key + '-' + i" :class="`infinite-loader draggable-list-item disabled loader-${_key}-${i}`">
      <div class="placeholder-wave">
        <span :class="['placeholder col-12', 'w-' + generateRandomIntFromInterval()]"></span>
      </div>
    </div>
  </div>
</template>

<script>
import { randomIntFromInterval, generateUID } from '@/helpers/randomId';

export default {
  props: {
    _key: {
      type: String,
      default: generateUID(),
      required: false
    },
    count: {
      type: Number,
      default: 5,
      required: false
    }
  },
  methods: {
    generateRandomIntFromInterval() {
      return [50, 75, 100][randomIntFromInterval()];
    },
  }
};
</script>